import { render, staticRenderFns } from "./product-details.vue?vue&type=template&id=77fef1e8&scoped=true&"
import script from "./product-details.vue?vue&type=script&lang=js&"
export * from "./product-details.vue?vue&type=script&lang=js&"
import style0 from "./product-details.vue?vue&type=style&index=0&id=77fef1e8&prod&scoped=true&lang=css&"
import style1 from "./product-details.vue?vue&type=style&index=1&id=77fef1e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fef1e8",
  null
  
)

export default component.exports